import React from 'react'
import styled from 'styled-components'

const BackgroundDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 60px;
`

const NotFoundPage = () => (
  <div>
    <BackgroundDiv>This feature is not available on mobile....</BackgroundDiv>
  </div>
)

export default NotFoundPage
